module.exports = __webpack_public_path__ + "static/media/poweredBySafety.25509d0a.svg";